import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserInfoService } from '../../../Services/user-info.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { Router } from '@angular/router';
import { AuthService } from '../../../Shared/Services/auth.service';
import { UserType } from '../../../Shared/Enums/UserType';
import { MatDialogRef } from '@angular/material/dialog';
import { SharedService } from '../../../Shared/Services/shared.service';
import { DialogService } from '../../../Shared/Services/dialog.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePassWordComponent {
  form!: FormGroup;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(private api: UserInfoService, private toastrService: CustomToastrService, private auth: AuthService,
    private spinner: NgxSpinnerService, private router: Router, private dialogRef: MatDialogRef<ChangePassWordComponent>
    , private dialogService: DialogService, private shared: SharedService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated()) {
      this.spinner.show();
      this.initForm();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  get f() {
    return this.form.controls;
  }

  initForm() {
    this.form = new FormGroup({
      CurrentPassword: new FormControl('', [Validators.required]),
      NewPassword: new FormControl('', [Validators.required])
    });

    this.spinner.hide();
  }

  Save() {
    if (this.form.valid) {
      this.dialogService.confirmDialog({
        titleKey: 'confirmation',
        messageKey: 'AreYouSuretoSaveThis',
        confirmTextKey: 'Yes',
        cancelTextKey: 'No'
      }).subscribe(isConfirmed => {
        if (isConfirmed) {
          this.ChangePassword(this.form.value);
        }
      });
    }
    else {
      this.shared.FireFormValidation(this.form);
    }
  }

  ChangePassword(form: any) {
    this.spinner.show();
    this.api.ChangePassword(form).pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (data: any) => {
            this.spinner.hide();
            if (data.isSuccess) {
              this.toastrService.showSuccessToast('Success', 'PasswordChangedSuccessfully');
              setTimeout(() => { this.router.navigateByUrl('dashboard/my-profile'); }, 600);
            } else {
              this.toastrService.showErrorToast('Error', data.message);
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
  }

  Cancel(): void {
    this.dialogRef.close();
  }
}
